export default __webpack_public_path__ + "img/TourStep3-f4896e24c55e368ac79c36aee48f00d1.png";